export const cpfIsValid = (cpf: string): boolean => {
  const cpfRegex = /^\d{3}.\d{3}.\d{3}-\d{2}$/
  if (cpfRegex.test(cpf)) {
    return true
  } else {
    return false
  }
}
